import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class FboMonolithAtsFieldMappingDataService {
  constructor(private apiService: ApiService) {}

  public clearCache(): Observable<void> {
    const path = 'AtsFieldMapping/cache';
    return this.apiService.httpDeleteRequest<void>(path);
  }

  public getAllowedStatusesForImport(): Observable<string[]> {
    const path = 'AtsFieldMapping/allowed-statuses-for-import';
    return this.apiService.httpGetRequest<string[]>(path);
  }
}
